import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Styled Elements
import { ModalBodyWrapper } from './RemoveApiKeyModal.elements'

// Views
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'views/components'

// Hooks
import { useRevokeIntegrationToken } from 'core/hooks/api'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function RemoveUserModal(props) {
  // Destructure
  const { ui, actions, auth } = props

  // Store State
  const { isRemoveApiKeyModalOpen } = ui
  const { apiKeyToDelete } = auth

  // Store Actions
  const { toggleRemoveApiKeyModal, setIsPageTableUpdated, setApiKeyToDelete } = actions

  // Hooks
  const { revokeIntegrationToken, revokeIntegrationTokenError, isRevokeIntegrationTokenLoading } =
    useRevokeIntegrationToken()

  // Functions
  const toggleModal = () => {
    toggleRemoveApiKeyModal()
  }
  const handleDeact = () => {
    revokeIntegrationToken({ jti: apiKeyToDelete.jti })
  }

  // UseEffect
  useEffect(() => {
    if (isRemoveApiKeyModalOpen) {
      if (!isRevokeIntegrationTokenLoading && !revokeIntegrationTokenError) {
        setIsPageTableUpdated(true)
        setApiKeyToDelete()
        toggleRemoveApiKeyModal()
      }
    }
  }, [isRevokeIntegrationTokenLoading])
  return (
    <Modal isOpen={isRemoveApiKeyModalOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>Remove API Key</ModalHeader>
      <ModalBody>
        {isRevokeIntegrationTokenLoading && <ModalBodyWrapper>Removing API Key...</ModalBodyWrapper>}
        {!isRevokeIntegrationTokenLoading && !revokeIntegrationTokenError && (
          <ModalBodyWrapper>Are you sure you want to remove this API Key?</ModalBodyWrapper>
        )}
        {!isRevokeIntegrationTokenLoading && revokeIntegrationTokenError && (
          <ModalBodyWrapper>An error occurred in removing API Key, please try again later.</ModalBodyWrapper>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          fullWidth
          type="button"
          onClick={toggleModal}
          variant="outlined"
          disabled={isRevokeIntegrationTokenLoading}
        >
          Cancel
        </Button>
        <Button
          fullWidth
          type="button"
          onClick={handleDeact}
          color="secondary"
          disabled={isRevokeIntegrationTokenLoading}
        >
          Remove
        </Button>
      </ModalFooter>
    </Modal>
  )
}

// Default Props
RemoveUserModal.defaultProps = {
  ui: {},
  form: {},
  actions: {},
}

// Proptypes Validation
RemoveUserModal.propTypes = {
  ui: PropTypes.shape({ isRemoveApiKeyModalOpen: PropTypes.bool }),
  form: PropTypes.shape({
    activityToRemove: PropTypes.shape({
      type: PropTypes.string,
      hash: PropTypes.string,
    }),
  }),
  auth: PropTypes.shape({
    apiKeyToDelete: PropTypes.shape({ jti: PropTypes.string }),
  }),
  actions: PropTypes.shape({
    toggleRemoveApiKeyModal: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    setApiKeyToDelete: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(RemoveUserModal)
